import { ActivityEvent } from './activity.service';

export interface ActivityGroup {
  companyId: number;
  // Nome de exibição; vazio quando a empresa não está na lista do usuário (cabeçalho mostra o id).
  name: string;
  current: boolean;
  events: ActivityEvent[];
}

/**
 * Agrupa o feed por empresa: a ativa primeiro; as outras filiais depois, a de alerta mais recente
 * antes. Dentro do grupo mantém a ordem do feed (mais novo primeiro).
 */
export function groupActivityByCompany(
  events: readonly ActivityEvent[],
  currentCompanyId: number | null,
  nameOf: (companyId: number) => string,
): ActivityGroup[] {
  const groups = new Map<number, ActivityGroup>();
  for (const event of events) {
    let group = groups.get(event.companyId);
    if (!group) {
      group = { companyId: event.companyId, name: nameOf(event.companyId), current: event.companyId === currentCompanyId, events: [] };
      groups.set(event.companyId, group);
    }
    group.events.push(event);
  }

  const newest = (g: ActivityGroup) => g.events.reduce((max, e) => (e.occurredAt > max ? e.occurredAt : max), '');
  return [...groups.values()].sort((a, b) =>
    a.current !== b.current ? (a.current ? -1 : 1) : newest(b).localeCompare(newest(a)));
}
